/**
 * Helper class to facilitate transaction processing
 * Call begin() to start a transaction, and end() to finish.
 * If begin() fails, that means a transaction is already in progress
 *
 * You can use this class directly,
 * or use the convenience helper function buildCapeTxnRunner
 */
export class CapeTransaction {

    constructor(txnName){
        if (typeof txnName !== 'string' || !txnName) {
            throw new TypeError(`${txnName} is not a valid transaction name`);
        }

        this.name = txnName;
        this.inProgress = false;
        this.count = 0;
    }

    begin = () => {
        this.count++;
        if (this.inProgress === true){
            this._log('multiple_ignore');
            return false;
        } else {
            this._log('started');
            return this.inProgress = true;
        }
    };

    end = () => {
        this.inProgress = false;
        this.count = 0;
        this._log('completed');
    };

    _log = (status) => {
        capeLog && capeLog(`submit_form="${this.name}", status=${status}, count=${this.count}`);
    };
}


/**
 * Returns a function that makes it simple to run transactions. See more details inside
  *
 * @param {String} txnName - name for this transaction. Used to identify transaction for logging.
 * @returns {Function}
 */
export const buildCapeTxnRunner = (txnName) => {
    // for the returned closure to operate the transaction
    const thisTxn = new CapeTransaction(txnName);

    /**
     * Run the callback if not in the middle of running the named transaction.
     * For async operations the callback should return a Promise
     * If the callback doesn't return a Promise, the response will be wrapped in a Promise
     *
     * @param {function} actionCb - what to run if transaction is allowed.
     * @returns {Promise}
     */
    return (actionCb) => {
        if (!thisTxn.begin()) {
            // If begin fails, then, there is another transaction in progress.
            // So, return immediately
            return Promise.resolve(`Transaction ${txnName} in progress`);
        }

        return new Promise(resolve => {
            return resolve(actionCb());
        }).then(cbResponse => {
            thisTxn.end();
            return cbResponse;
        }).catch(cbReason => {
            capeLog && capeLog(`actionCb in txn ${txnName} was rejected`);
            thisTxn.end();
            return Promise.reject(cbReason);
        });
    };
};


